import StudentProgressService from "../../services/StudentProgress";
import { Clazz, Move } from "../../types";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

export const QUERY_KEY = "student-progressions";

export interface UseListStudentProgress {
  clazz?: Clazz["id"];
  move?: Move["id"];
}

export const makeQueryKey = ({ clazz, move }: UseListStudentProgress) => [
  QUERY_KEY,
  clazz,
  move,
];

function useListStudentProgress({ clazz, move }: UseListStudentProgress) {
  const key = makeQueryKey({ clazz, move });

  return useAuthorizedQuery(key, () =>
    StudentProgressService.listStudentProgressions({ clazz, move })
  );
}

export default useListStudentProgress;
